module.exports = __webpack_public_path__ + "pc/img/consultant.d4d0fe27.png";